export enum CurrencyEnumDto {
    Euro = 'Euro',
}
